import { createEvent, sample } from 'effector'
import {
  NotificationPayload,
  showNotification,
} from '../../../../features/notifications'
import { fx } from '../../../../libs/request'
import { WalletGuardWallet } from '../../types'
import { walletNameFromAddress } from '../create/model'
import { EditWalletRequest, EditWalletSubmit } from './types'

// Собирает запрос на редактирование из значений формы: убирает лишние
// пробелы, подставляет название по умолчанию, убирает повторы в платёжных
// системах. Финальный кошелёк передаём только для транзитного.
export const buildEditWalletRequest = ({
  wallet,
  values,
}: EditWalletSubmit): EditWalletRequest => {
  const body: EditWalletRequest = {
    name: values.name.trim() || walletNameFromAddress(wallet.address),
    paymentSystems: Array.from(
      new Set(
        values.paymentSystems.map((value) => value.trim()).filter(Boolean),
      ),
    ),
    comment: values.comment.trim() || null,
  }

  if (wallet.type.toUpperCase() === 'TRANSIT') {
    body.finalWalletId = values.finalWalletId ?? undefined
  }

  return body
}

// Запрос на редактирование кошелька.
export const editWalletFx = fx<EditWalletRequest, WalletGuardWallet>({
  method: 'PATCH',
})

// Пользователь отправил форму.
export const walletEditSubmitted = createEvent<EditWalletSubmit>()

// Ошибки по конкретным полям формы от сервера. Компонент показывает их
// под нужными полями.
export const editWalletValidationFailed = editWalletFx.failData.filterMap(
  (error) => error?.body?.details?.validationErrors?.items,
)

sample({
  clock: walletEditSubmitted,
  fn: (submit) => ({
    url: `/wallet-guard/wallets/${submit.wallet.id}`,
    body: buildEditWalletRequest(submit),
  }),
  target: editWalletFx,
})

sample({
  clock: editWalletFx.done,
  fn: (): NotificationPayload => ({
    type: 'success',
    description: 'Кошелёк сохранён',
  }),
  target: showNotification,
})

sample({
  clock: editWalletFx.failData,
  fn: (error): NotificationPayload => ({
    type: 'error',
    description: error?.body?.message ?? 'Не удалось сохранить кошелёк',
  }),
  target: showNotification,
})
